import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'html-react-parser';
import axios from "axios";
import { apiHost, getwayApi } from '../../../config/Constants';
import { LoadingScreen } from '../../components/LoadingScreen/LoadingScreen'
import copyIcon from './styles/assets/copy-icon.png';
import vzaLogo from '../form/styles/assets/verisma_logo.png';
import './styles/css/confirmation.css';
import './styles/confirmation.scss'
import { testConfSpec } from '../../../context/confSpec_patient'
import Button from '../../components/Button/Button'
import { CheckLanguage } from '../../languages/languages';
import { GetLanguageText } from '../../languages/languages';

export const PatientConfirmationPage = ({ session, config, formId }) => {

    const logData = window.location.origin.includes('app-vra.azurewebsites.net') || window.location.origin.includes('app-vra-test') || window.location.origin.includes('localhost');

    // only log if in dev
    function log(str) {
        if (logData) {
            console.log(str);
        }
    }

    const delay = millis => new Promise((resolve, reject) => {
        setTimeout(_ => resolve(), millis)
    });

    const [userData, setUserData] = useState(null);

    const doFetch = async () => {
        let tryCount = 20;

        for (var iTry = 0; iTry < tryCount; iTry++) {
            log("Access code fetch: " + iTry.toString());

            try {
                let response = await axios
                    .get(`${apiHost}/api/accessCode/v2?session=${session}&_=${new Date().getTime()}`)
                    .catch(err => {
                        log("Error in fetching results.");
                        log(err);
                    });

                if (response && response.status === 200) {
                    log("Response came back.");
                    log(response);
                    setUserData(response.data);
                    break;

                } else {
                    log("Invalid response");
                    log(response);
                    await delay(2000); // sleep for 2 seconds before retrying.
                }
            } catch (error) {
                log("Error in fetching results.");
                log(error);
            }
        }
    };
    useEffect(() => {
        log("Do fetch");
        doFetch();
    }, []);


    const formColor = config.context.trackRequest.trackingButton.styles.backgroundColor;
    let languageID = CheckLanguage(config);

    if (languageID != "default") {
        const languageText = GetLanguageText(languageID);

        if (config && userData) { // Loading screen split.
            return (
                <div id='confirmation-content-container' className='page'>

                    <img
                        id='confirmation-logo'
                        style={{ width: config.context.logo.width }}
                        src={`${getwayApi}/api/client/logo/${formId}`}
                    />

                    <h4
                        className='header'
                        style={{ color: formColor }}>
                        {`${languageText.PatientConfirmation.Header.RequestSubmitted}`}
                    </h4>

                    <div id='confirmation-paragraphs-container'>
                        <p className='confirmation-p-text body1' >
                            {/* {ReactHtmlParser(config.context.textBody.paragraphs.formSend.replace("(email address here)", userData.email))} */}
                            {languageText.PatientConfirmation.Body.EmailTarget} <strong>{userData.email}.</strong>
                        </p>

                        <p className='confirmation-p-text body1' >
                            {/* {ReactHtmlParser(config.context.textBody.paragraphs.releaseSend)} */}
                            {languageText.PatientConfirmation.Body.AdditionalEmail}
                        </p>
                    </div>

                    <div id='confirmation-tracking-container'>
                        <p className='overline'>{languageText.PatientConfirmation.Body.AccessCode}</p>
                        <p className='' id='tracking-number'>{userData.vrmAccessCode}</p>
                        <Button label={`${languageText.PatientConfirmation.Buttons.TackRequest}`} onClick={() => { window.open(`${config.context.trackRequest.trackingButton.trackingLink}${userData.vrmAccessCode}`, '_blank') }} style={{ backgroundColor: formColor }} classes={'tracking-button'} />
                    </div>

                    <div id='confirmation-feedback-container' style={{ backgroundColor: formColor }}>
                        <div id='confirmation-feedback-text-container'>
                            <h5>{`${languageText.PatientConfirmation.Header.WelcomeFeedback}`}</h5>
                            <a href='https://is.gd/vraasurvey' target="_blank" className='link-text'>{`${languageText.PatientConfirmation.Body.SurveyButton}`}</a>
                            {/* <p style={config.context.survery.linkStyle}> {ReactHtmlParser(config.context.survery.linkText.replace("(survery link)", userData.specProps.SurveryLink))} </p> */}

                        </div>
                    </div>
                </div>
            );
        } else {
            return (<LoadingScreen loadingMessage={`${languageText.PatientConfirmation.Buttons.LoadingScreenText}`} />)
        }
    } else {
        if (config && userData) {
            return (
                <div id='confirmation-content-container' className='page'>

                    <img
                        id='confirmation-logo'
                        style={{ width: config.context.logo.width }}
                        src={`${getwayApi}/api/client/logo/${formId}`}
                    />

                    <h4
                        className='header'
                        style={{ color: formColor }}>
                        {'Your request has been submitted'}
                    </h4>

                    <div id='confirmation-paragraphs-container'>
                        <p className='confirmation-p-text body1' >
                            {/* {ReactHtmlParser(config.context.textBody.paragraphs.formSend.replace("(email address here)", userData.email))} */}
                            We’ll send a copy of the submitted request form, along with additional information, to your email at <strong>{userData.email}.</strong>
                        </p>

                        <p className='confirmation-p-text body1' >
                            {/* {ReactHtmlParser(config.context.textBody.paragraphs.releaseSend)} */}
                            We’ll send you an additional email when the requested records are ready for release. In the meantime, you can track your request using your access code.
                        </p>
                    </div>

                    <div id='confirmation-tracking-container'>
                        <p className='overline'>Access Code</p>
                        <p className='' id='tracking-number'>{userData.vrmAccessCode}</p>
                        <Button label={'Track Request'} onClick={() => { window.open(`${config.context.trackRequest.trackingButton.trackingLink}${userData.vrmAccessCode}`, '_blank') }} style={{ backgroundColor: formColor }} classes={'tracking-button'} />
                    </div>

                    <div id='confirmation-feedback-container' style={{ backgroundColor: formColor }}>
                        <div id='confirmation-feedback-text-container'>
                            <h5>{'We welcome your feedback'}</h5>
                            <a href='https://is.gd/vraasurvey' target="_blank" className='link-text'>{'Click here to help us improve your experience by taking our short survey'}</a>
                            {/* <p style={config.context.survery.linkStyle}> {ReactHtmlParser(config.context.survery.linkText.replace("(survery link)", userData.specProps.SurveryLink))} </p> */}

                        </div>
                    </div>
                </div>
            );
        } else {
            return (<LoadingScreen loadingMessage={"Finalizing your request. We'll be just a moment."} />)
        }
    }
}